// @flow
// $FlowFixMe
import React, { useEffect, useState } from "react";
import { get, noop } from "lodash";
import Logo from "@fdr/static-ui/Logos";
import type { Brand } from "@tvg/types/Product";
import type { NullaryFn } from "@tvg/types/Functional";
import Icon from "@fdr/static-ui/Icons";
import { arrowLeft } from "@fdr/static-ui/Icons/icons";
import { InboxButton } from "@urp/braze-inbox";
import {
  Container,
  LogoNavigationContainer,
  LogoContainer,
  LinkContainer,
  TitleContainer
} from "./styled-components";
import Text from "../../_atoms/Text";
import type { AlignmentEnum } from "../../_atoms/Text/styled-components";
import AddFundsButton from "../../_molecules/AddFundsButton";

type Props = {
  title: string,
  logoMod: string,
  isLogged: boolean,
  isActionToolsShown?: boolean,
  brand: Brand,
  onQuickDeposit?: NullaryFn<void>,
  onLogoClick: NullaryFn<void>,
  onBackClick: NullaryFn<void>,
  prevPath: string,
  backgroundColor: string,
  color: string,
  arrowColor: string,
  fontSize?: number | null,
  iconSize?: number | null,
  height?: number | null,
  align: AlignmentEnum,
  hasBottomBorder: boolean,
  homeState?: string
};

const Header = (props: Props) => {
  const [previousPath, setPreviousPath] = useState(props.prevPath);
  const finalPath =
    previousPath && previousPath !== "/" ? previousPath : "/home";

  useEffect(() => {
    if (typeof window !== "undefined") {
      const { pathname } = window.location;
      if (props.prevPath !== pathname) setPreviousPath(props.prevPath);
    }
  }, [props.prevPath]);

  const renderLogo = () => {
    switch (props.logoMod) {
      case "title":
        return (
          <TitleContainer>
            <Text
              fontSize={props.fontSize || 16}
              color={props.color}
              qaLabel={`headerTitle${props.title.split(" ").join("")}`}
            >
              {props.title}
            </Text>
          </TitleContainer>
        );
      case "navigation":
        return (
          <LinkContainer
            to={finalPath}
            onClick={props.onBackClick}
            align={props.align}
          >
            <Icon
              icon={arrowLeft}
              size={props.iconSize || 24}
              color={props.arrowColor}
            />
            <Text
              fontSize={props.fontSize || 18}
              color={props.color}
              qaLabel={`headerTitle${props.title.split(" ").join("")}`}
              align={props.align}
            >
              {props.title}
            </Text>
          </LinkContainer>
        );
      default:
        return (
          <LogoContainer to="/" onClick={props.onLogoClick}>
            <Logo
              onClick={props.onLogoClick}
              brand={get(props, "brand")}
              homeState={get(props, "homeState")}
              height={30}
              width={106}
            />
          </LogoContainer>
        );
    }
  };

  const renderLoggedInActionTools = () => [
    props.onQuickDeposit && (
      <AddFundsButton onClick={props.onQuickDeposit} key="funds-button" />
    ),
    <InboxButton key="inbox-button" />
  ];

  return (
    <Container
      data-qa-label="header"
      $height={props.height || 48}
      backgroundColor={props.backgroundColor}
      hasBottomBorder={props.hasBottomBorder}
    >
      <LogoNavigationContainer>{renderLogo()}</LogoNavigationContainer>
      {get(props, "isLogged", false) &&
        get(props, "isActionToolsShown", true) &&
        renderLoggedInActionTools()}
    </Container>
  );
};

Header.defaultProps = {
  title: "",
  isLogged: false,
  isActionToolsShown: true,
  onLogoClick: noop,
  onBackClick: noop,
  quickDeposit: {
    url: "/",
    onClick: noop
  },
  brand: "tvg",
  logoMod: "normal",
  prevPath: "",
  backgroundColor: "",
  color: "",
  arrowColor: "",
  fontSize: null,
  iconSize: null,
  height: null,
  align: "inherit",
  hasBottomBorder: false,
  homeState: undefined
};

export default Header;
